(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-faqs"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener("DOMContentLoaded", function() {
  const faqItems = document.querySelectorAll(".faq-item");

  faqItems.forEach(item => {
    const question = item.querySelector(".faq-question");
    const iconContainer = item.querySelector(".faqs-icon"); // parent icon wrapper
    const icon = iconContainer ? iconContainer.querySelector(".icon-plus, .icon-minus") : null;

    if (question) {
      question.addEventListener("click", function() {
        item.classList.toggle("active");

        const answer = item.querySelector(".faq-answer");

        if (answer) {
          if (item.classList.contains("active")) {
            answer.style.maxHeight = answer.scrollHeight + "px";
            if (icon) {
              icon.classList.remove("icon-plus");
              icon.classList.add("icon-minus");
            }
          } else {
            answer.style.maxHeight = null;
            if (icon) {
              icon.classList.remove("icon-minus");
              icon.classList.add("icon-plus");
            }
          }
        }
      });
    }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-category"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRail(scope) {
    var sections = (scope || document).querySelectorAll('.shop_cat_section--rail');
    for (var i = 0; i < sections.length; i++) {
      (function (sec) {
        if (sec.dataset.scRailReady === '1') return;
        sec.dataset.scRailReady = '1';

        var rail = sec.querySelector('.shop_cat_rail');
        var prev = sec.querySelector('.shop_cat_nav--prev');
        var next = sec.querySelector('.shop_cat_nav--next');
        if (!rail) return;

        function stepBy(dir) {
          var card = rail.querySelector('.shop_cat_card');
          var gap = parseFloat(getComputedStyle(rail).columnGap) || 20;
          var dist = card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
          rail.scrollBy({ left: dir * dist, behavior: 'smooth' });
        }

        function syncArrows() {
          var max = rail.scrollWidth - rail.clientWidth - 2;
          var scrollable = max > 2;
          if (prev) prev.hidden = !scrollable || rail.scrollLeft <= 2;
          if (next) next.hidden = !scrollable || rail.scrollLeft >= max;
        }

        if (prev) prev.addEventListener('click', function () { stepBy(-1); });
        if (next) next.addEventListener('click', function () { stepBy(1); });

        var ticking = false;
        rail.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () { syncArrows(); ticking = false; });
        }, { passive: true });

        if ('ResizeObserver' in window) {
          new ResizeObserver(syncArrows).observe(rail);
        } else {
          window.addEventListener('resize', syncArrows, { passive: true });
        }

        syncArrows();
      })(sections[i]);
    }
  }

  if (document.readyState !== 'loading') {
    initRail(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () { initRail(document); });
  }

  document.addEventListener('shopify:section:load', function (e) { initRail(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });

  } catch(e) { console.error(e); }
})();
})();
